<template>
  <v-app>
    <div id="return-to-top"></div>

    <v-navigation-drawer app v-model="drawer" style="font-family: 'Nico Moji'; background:#303F9F; overflow-y:scroll;">
      <v-list nav dense>
        <v-list-item-group>
          <v-list-item>
            <v-list-item-title style="color: white;" @click="onHome">HOME</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title style="color: white;" @click="onAbout">ABOUT</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title style="color: white;" @click="onPolicy">POLICY</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app style="background-color: #303F9F;">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" style="color:white;"></v-app-bar-nav-icon>
      <v-toolbar-title style="font-family: 'Nico Moji'; padding:0px;">
        <router-link to="/" style="text-decoration: none; font-size: 32px; color: white;">
          Mosaic
        </router-link>
      </v-toolbar-title> 
    </v-app-bar>

    <v-content>
      <router-view></router-view>
      
      <v-footer dark padless >
        <v-card class="flex" flat tile>
          <v-card-title color="#333333">
            <v-btn class="mx-2" fab small color="white" href="https://twitter.com/w2or3w" target="_blank">
              <v-icon color="#333333" size="24px">mdi-twitter</v-icon>
            </v-btn>
            <v-btn class="mx-2" fab small color="white" href="https://www.facebook.com/w2or3w" target="_blank">
              <v-icon color="#333333" size="24px">mdi-facebook</v-icon>
            </v-btn>
            <v-btn class="mx-2" fab small color="white" href="https://www.instagram.com/w2or3w" target="_blank">
              <v-icon color="#333333" size="24px">mdi-instagram</v-icon>
            </v-btn>
          </v-card-title>
    
          <v-card-text class="py-2 white--text text-left" color="#757575">
            <p style="width:100%; margin:0px;"><strong>mosaic.w2or3w.com</strong></p>
            <router-link to="policy" style="text-decoration: none;"><p style="font-size: 12px; color: white; display:inline-block;">PRIVACY POLICY</p></router-link>
          </v-card-text>
        </v-card>
      </v-footer>
    </v-content>

    <div id="return-to-bottom"></div>

    <input style="display: none" 
      ref="input" type="file" 
      @change="uploadSelectedFile()">

    <transition name="fade">
      <v-btn fab fixed small right v-scroll-to="{ element: '#return-to-top', duration: 1000 }"
        color="#BDBDBD88"
        style="top: 64px"
        v-show="this.isShowUp"
        >
        <v-icon color="white">mdi-chevron-up</v-icon>
      </v-btn>
    </transition>
      
    <transition name="fade">
      <v-btn fab fixed small right v-scroll-to="{ element: '#return-to-bottom', duration: 1000, offset: this.innerHeight * -1 }"
        color="#BDBDBD88"
        style="bottom: 16px"
        v-show="this.isShowDown"
        >
        <v-icon color="white">mdi-chevron-down</v-icon>
      </v-btn>
    </transition>

  </v-app>
</template>

<script>
import Vue from "vue";
import { eventBus } from "./main";
import { Auth, Storage, API, graphqlOperation } from 'aws-amplify';
import { listMosaicProdTables } from "./graphql/queries";

import imageResize from './assets/js/imageResize.js';
import VueScrollTo from "vue-scrollto";
Vue.use(VueScrollTo, {
  container: "body",
  easing: "ease", 
  cancelable: true
});

export default {
  name: 'App',
  components: {
  },
  
  data: () => ({
    drawer: false,
    isShowUp: false,
    isShowDown: false, 
    innerHeight: 0,
  }),

  mounted: async function() {
    this.login();

    window.addEventListener("scroll", this.onScreenEvent);
    window.addEventListener("resize", this.onScreenEvent);
    window.addEventListener("load", () => {
      this.onScreenEvent();
    });
  }, 

  created() {
    eventBus.$on("onSelectImage", ()  => {
      this.onSelectImage();
    });
    
    eventBus.$on("onScreenEvent", ()  => {
      this.onScreenEvent();
    });

    eventBus.$on("getGUIDString", (dt)  => {
      this.getGUIDString(dt);
    });
  }, 

  methods:{
    onHome() {
      if(this.$route.path != '/'){
        this.$router.push({ path: '/' });
        this.login();
      }
    }, 
    onAbout() {
      if(this.$route.path != '/about'){
        this.$router.push({ path: 'about' });
      }
    }, 
    onPolicy() {
      if(this.$route.path != '/policy'){
        this.$router.push({ path: 'policy' });
      }
    }, 
    
    async login() {
      Auth.currentSession()
        .then(data => {
          console.log(data);
        })
        .catch(err => {
          console.log(err);
          this.signinAccount("mosaic-prod-user");
        });
      this.checkVersion();
    },
    
    async checkVersion() {
      let apiResult = await API.graphql(graphqlOperation(listMosaicProdTables, { group : "mosaic_version" }));
      let version = apiResult.data.listMosaicProdTables.items[0].path;

      console.log("version : " + version);
      var versionCookies = Cookies.get('mosaic.w2or3w.com.version');
      Cookies.set('mosaic.w2or3w.com.version', version, { expires: 1 });
      if(version != versionCookies){
        window.navigator.serviceWorker.getRegistrations()
        .then(registrations => {
          for(let registration of registrations) {
            registration.unregister();
          }
        });
        window.location.reload(true);
      }
    }, 
    
    signinAccount(account) {
      console.log("login.");
      Auth.signIn(account, account)
        .then((data) => {
          if(data.challengeName == "NEW_PASSWORD_REQUIRED"){
            console.log("new password required.");
            data.completeNewPasswordChallenge(account, {}, 
              {
                onSuccess(result) {
                    console.log("onSuccess");
                    console.log(result);
                },
                onFailure(err) {
                    console.log("onFailure");
                    console.log(err);
                }
              }
            );
          }
          console.log("login successfully.");
          this.checkVersion();
        }).catch((err) => {
          console.log("login failed.");
          console.log(err);
        });
    }, 
    
    onScreenEvent() {
      const btnHeightUpDown = 32;
      this.isShowUp = window.pageYOffset >= btnHeightUpDown;
      const scrollHeight = Math.max(
        document.body.scrollHeight, document.documentElement.scrollHeight,
        document.body.offsetHeight, document.documentElement.offsetHeight,
        document.body.clientHeight, document.documentElement.clientHeight
      );
      const pageMostBottom = scrollHeight - window.innerHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.isShowDown = scrollTop + btnHeightUpDown < pageMostBottom;
      
      this.innerHeight = window.innerHeight;
    },
    
    onSelectImage() {
      if(this.$refs.input != undefined){
        this.$refs.input.click();
      }
    }, 
    
    async uploadSelectedFile() {
      let file = this.$refs.input.files[0];
      if(file == undefined){
        return;
      }
      console.log(file);

      let dt = new Date();
      let dirName = this.getGUIDString(dt);
      let filePath = dirName + "/" + file.name;
      this.$router.push({ path: 'list', query: { group: dirName }});
      
      const src = await imageResize.pFileReader(file);
      const img = await imageResize.pImage(src);
      const resizedImg = await imageResize.resizeImage(img, 1000, 'image/png');
      
      Storage.put(filePath, resizedImg).then(result => {
        console.log(result);
      }).catch(err => console.log(err));
    }, 

    getGUIDString(date){
      let random = date.getTime() + Math.floor(100000 * Math.random());
      random = Math.random() * random;
      random = Math.floor(random).toString(16);
      return "" + 
        ("00" + date.getUTCFullYear()).slice(-2) + 
        ("00" + (date.getMonth() + 1)).slice(-2) + 
        ("00" + date.getUTCDate()).slice(-2) + 
        ("00" + date.getUTCHours()).slice(-2) + 
        ("00" + date.getUTCMinutes()).slice(-2) + 
        ("00" + date.getUTCSeconds()).slice(-2) + 
        "-" + random;
    }, 
    
  }
};
</script>

<style>
@import "https://fonts.googleapis.com/earlyaccess/nicomoji.css";
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
